export default function WeeklyThoughts() {
  const thoughts = [
    {
      title: "Don't let your yesterdays or your tomorrows take up too much of your today",
      excerpt: "Honour yesterday without dragging it around; Prepare for tomorrow without fearing it; Choose to live in today.",
      date: "Week of Jan 15, 2025",
      type: "Article"
    },
  ];

  return (
    <section id="weekly-thoughts" className="py-24 bg-gradient-to-b from-white to-[#F0F4F8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#E8F1F5] text-[#2F7FB7] px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-lightbulb-line"></i>
            Weekly Inspiration
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
            Weekly Inspirational Thoughts
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Every week, receive thoughtful insights and practical wisdom to support your mental wellness journey. 
            Articles and videos designed to inspire reflection and positive change.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {thoughts.map((thought, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all group cursor-pointer">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-sm text-[#2F7FB7] font-medium bg-[#E8F1F5] px-3 py-1 rounded-full">
                  {thought.type}
                </span>
                <span className="text-sm text-gray-500">{thought.date}</span>
              </div>
              <h3 className="text-xl font-serif text-gray-900 mb-3 group-hover:text-[#2F7FB7] transition-colors">
                {thought.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {thought.excerpt}
              </p>
              <div className="flex items-center justify-between">
                <a href="/download" className="text-[#2F7FB7] font-medium inline-flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap cursor-pointer">
                  Read & Watch
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
                <i className="ri-video-line text-2xl text-gray-400 group-hover:text-[#2F7FB7] transition-colors"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}